import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDownload, FiStar, FiUsers, FiGift } = FiIcons;

const Hero = () => {
  return (
    <section className="pt-32 pb-20 px-6">
      <div className="container mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="inline-flex items-center space-x-2 bg-rose-accent/20 text-rose-dark px-4 py-2 rounded-full text-sm font-medium mb-8"
          >
            <SafeIcon icon={FiStar} className="text-rose-primary" />
            <span>The Ultimate Gift List Experience</span>
          </motion.div>

          {/* Main Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="text-5xl md:text-7xl font-bold mb-6 leading-tight"
          >
            <span className="bg-gradient-to-r from-rose-primary via-rose-secondary to-rose-accent bg-clip-text text-transparent">
              Gifter's Choice
            </span>
            <br />
            <span className="text-gray-800">Makes Gift Giving</span>
            <br />
            <span className="text-gray-600">Effortless</span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="text-xl md:text-2xl text-gray-600 mb-12 max-w-3xl mx-auto leading-relaxed"
          >
            Create the perfect gift list by importing products from any store. 
            Organize by wants and needs, then let your gifters choose what matters most.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.8 }}
            className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 mb-16"
          >
            <motion.a
              href="#download"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-gradient-to-r from-rose-primary to-rose-secondary text-white px-8 py-4 rounded-full font-semibold text-lg flex items-center space-x-3 shadow-xl hover:shadow-2xl transition-all"
            >
              <SafeIcon icon={FiDownload} className="text-xl" />
              <span>Download for iOS</span>
            </motion.a>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="border-2 border-rose-primary text-rose-primary px-8 py-4 rounded-full font-semibold text-lg hover:bg-rose-primary hover:text-white transition-all"
            >
              Watch Demo
            </motion.button>
          </motion.div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 0.8 }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-2xl mx-auto"
          >
            <div className="text-center">
              <div className="text-3xl font-bold text-rose-primary mb-2">10K+</div>
              <div className="text-gray-600">Happy Users</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-rose-primary mb-2">50K+</div>
              <div className="text-gray-600">Gift Lists Created</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-rose-primary mb-2">4.9★</div>
              <div className="text-gray-600">App Store Rating</div>
            </div>
          </motion.div>
        </motion.div>

        {/* Floating Icons */}
        <div className="absolute top-1/2 left-10 hidden lg:block">
          <motion.div
            animate={{ y: [0, -20, 0] }}
            transition={{ duration: 3, repeat: Infinity }}
            className="w-16 h-16 bg-gradient-to-br from-rose-accent to-rose-secondary rounded-2xl flex items-center justify-center shadow-lg"
          >
            <SafeIcon icon={FiGift} className="text-white text-2xl" />
          </motion.div>
        </div>

        <div className="absolute top-1/3 right-10 hidden lg:block">
          <motion.div
            animate={{ y: [0, -15, 0] }}
            transition={{ duration: 4, repeat: Infinity, delay: 1 }}
            className="w-12 h-12 bg-gradient-to-br from-rose-primary to-rose-dark rounded-xl flex items-center justify-center shadow-lg"
          >
            <SafeIcon icon={FiUsers} className="text-white text-xl" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;